/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddBusinessOTPRequest
 */
export interface AddBusinessOTPRequest {
    /**
     * 
     * @type {string}
     * @memberof AddBusinessOTPRequest
     */
    challenge_id: string;
    /**
     * 
     * @type {string}
     * @memberof AddBusinessOTPRequest
     */
    code: string;
}

/**
 * Check if a given object implements the AddBusinessOTPRequest interface.
 */
export function instanceOfAddBusinessOTPRequest(value: object): value is AddBusinessOTPRequest {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function AddBusinessOTPRequestFromJSON(json: any): AddBusinessOTPRequest {
    return AddBusinessOTPRequestFromJSONTyped(json, false);
}

export function AddBusinessOTPRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddBusinessOTPRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'code': json['code'],
    };
}

export function AddBusinessOTPRequestToJSON(json: any): AddBusinessOTPRequest {
    return AddBusinessOTPRequestToJSONTyped(json, false);
}

export function AddBusinessOTPRequestToJSONTyped(value?: AddBusinessOTPRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'code': value['code'],
    };
}

